import { z } from 'zod';
export const votingScaleSizeValues = ['small', 'medium', 'large'];
export const sessionStatusValues = ['created', 'active'];
export const VotingScaleSizeSchema = z.enum(votingScaleSizeValues);
export const SessionStatusSchema = z.enum(sessionStatusValues);
export const VotingScaleOptionSchema = z.object({
    label: z.string().trim().min(1).max(64),
    value: z.string().trim().min(1).max(64),
});
function hasUniqueOptionValues(options) {
    return new Set(options.map((option) => option.value)).size === options.length;
}
export const VotingScaleSizeOptionsSchema = z
    .array(VotingScaleOptionSchema)
    .min(1)
    .max(32)
    .refine(hasUniqueOptionValues, 'Option values must be unique within the same size bucket');
export const VotingScaleOptionsSchema = z.object({
    small: VotingScaleSizeOptionsSchema,
    medium: VotingScaleSizeOptionsSchema,
    large: VotingScaleSizeOptionsSchema,
});
const groupAndVariantConsistencyCheck = (value, ctx) => {
    const hasGroupKey = value.groupKey !== null;
    const hasVariantKey = value.variantKey !== null;
    if (hasGroupKey !== hasVariantKey) {
        ctx.addIssue({
            code: 'custom',
            path: ['groupKey'],
            message: 'groupKey and variantKey must both be set or both be null',
        });
    }
};
export const VotingScaleSchema = z
    .object({
    id: z.uuid(),
    userId: z.uuid(),
    name: z.string().trim().min(1).max(120),
    description: z.string().trim().max(500).nullable(),
    groupKey: z.string().trim().min(1).max(120).nullable(),
    variantKey: z.string().trim().min(1).max(120).nullable(),
    options: VotingScaleOptionsSchema,
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
    deletedAt: z.iso.datetime().nullable(),
})
    .superRefine(groupAndVariantConsistencyCheck);
export const UpsertVotingScaleRequestSchema = z
    .object({
    name: z.string().trim().min(1).max(120),
    description: z.string().trim().max(500).nullable(),
    groupKey: z.string().trim().min(1).max(120).nullable(),
    variantKey: z.string().trim().min(1).max(120).nullable(),
    options: VotingScaleOptionsSchema,
})
    .superRefine(groupAndVariantConsistencyCheck);
export const AssignSessionVotingScalePayloadSchema = z.object({
    sessionId: z.uuid(),
    votingScaleId: z.uuid(),
    votingScaleSize: VotingScaleSizeSchema,
});
export const RoundVotingScaleSnapshotSchema = z.object({
    votingScaleId: z.uuid(),
    name: z.string().trim().min(1).max(120),
    description: z.string().trim().max(500).nullable(),
    size: VotingScaleSizeSchema,
    options: VotingScaleSizeOptionsSchema,
});
//# sourceMappingURL=voting-scale.js.map